export const PROMPTS = ["",
    "You are acting out a [dream,dream].$\n" +
    "\n" +
    "The dream starts exactly where you exist reading this.$ You're the main character!$\n",
    // "\n" +
    "What was something that you contemplated doing today or in the recent past that you didn’t end up doing? $ something you would do if you had more [time,money,time,time,time]?",
    "Now imagine you have set out to do that thing.$ Play it out in your head.$ How are you getting to the place?", "$  Remember, being a [dream,dream] you don’t need to confine yourself to [reality,reality]. $" +
    "Now, choose someone you know that [confuses,excites,terrifies] you.$ This person can be real. $ What's their name?",
    "Ok, you accidentally run into {person} once you get there! $ Why are they there?", "What happens next?"];

export const DESCRIPTION =
    "I am a framework for ideating stories using a speech-to-text interface. $" +
    "" +
    "A recipe of memories - imagination and a dash of imposed narrative structure.$ poof!$ $Storytelling as easy as daydreaming. ";
var yest = "$The structure of the " +
    "exercise was inspired by the epiphanic narrative structure in modern structuralist theory.$ My main goals were to " +
    "explore freeflowing storytelling with retro-active structuring as well as to explore the line between our external and internal models of reality.";

export const SPEAK = ["Now enlighten Me.", "Go Ahead, I'm Listening.", "Say Whatever comes to mind... or meditate on it, that works too.", "Pretend I'm your mom after a particularly hard day. I'm all ears."]


// Be invested in the piece.
// Rely on someone else to acomplish what they want
// To maximize sustained attention towards the activity.
// and have a deeper emotional experience with the group. To feel belonging. to feel both seen and unseen.